import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
const TRACKING_ID = import.meta.env.VITE_GA_ID; // OUR_TRACKING_ID
if (import.meta.env.PROD) {
ReactGA.initialize(TRACKING_ID);
}


const GaTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (import.meta.env.PROD) {
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [location.key])

  return (<></>);
}

export default GaTracker;